import { createRef } from 'react'

let state = {
  sections: 2,
  pages: 2,
  zoom: 1,
  top: createRef()
}

export default state
